"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M17.8601 16.2471C18.1591 16.5251 17.9471 17.0001 17.5241 17.0001H11.5981C11.3761 17.0001 11.2641 16.7301 11.4221 16.5731L13.0021 15.0001L14.6651 13.2241C14.8501 13.0511 15.1521 13.0511 15.3381 13.2241L17.8601 16.2471ZM12.1164 14.1152C12.2144 14.2132 12.2144 14.3712 12.1164 14.4692L9.72342 16.8542C9.62942 16.9472 9.50242 17.0002 9.37042 17.0002H2.69142C1.98642 17.0002 1.77442 16.2202 2.27342 15.7642L7.45942 10.4622C7.76942 10.1792 8.27042 10.1792 8.58042 10.4622L9.00042 10.8912V6.33318V4.66718V3.00018H14.0004V7.00018H10.0004V12.0002L12.1164 14.1152Z",
    fill: "#727B7F"
  }));
};